/**
 * @generated SignedSource<<afe11d48ea70b28224ad6568c29e49bd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TriggerIdentityProviderSyncInput = {
  identityProviders?: ReadonlyArray<string> | null | undefined;
};
export type TriggerIdentityProviderSyncMutation$variables = {
  input: TriggerIdentityProviderSyncInput;
};
export type TriggerIdentityProviderSyncMutation$data = {
  readonly triggerIdentityProviderSync: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type TriggerIdentityProviderSyncMutation = {
  response: TriggerIdentityProviderSyncMutation$data;
  variables: TriggerIdentityProviderSyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TriggerIdentityProviderSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TriggerIdentityProviderSyncPayload",
        "kind": "LinkedField",
        "name": "triggerIdentityProviderSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TriggerIdentityProviderSyncMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TriggerIdentityProviderSyncPayload",
        "kind": "LinkedField",
        "name": "triggerIdentityProviderSync",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbc544c79496cc811d56eacf1fe885a7",
    "id": null,
    "metadata": {},
    "name": "TriggerIdentityProviderSyncMutation",
    "operationKind": "mutation",
    "text": "mutation TriggerIdentityProviderSyncMutation(\n  $input: TriggerIdentityProviderSyncInput!\n) {\n  triggerIdentityProviderSync(input: $input) {\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ccc7eb1169cba7bc16fc41e9ef34466";

export default node;
